import { ReducerFactory } from "./reducers/reducer.factory";
import { GlobalStore } from 'redux-micro-frontend';
import { FxpServiceFactory, FXPServiceCatalog } from '@fxp/fxpservices-di';
import { DefaultRouteState } from './common/models/route.state';
var PLATFORM_ROUTER_STORE_NAME = "PLATFORM_ROUTER";
var PlatformStateRouter = /** @class */ (function () {
    function PlatformStateRouter(globalStore, fxpRouterService, reducerFactory) {
        this._globalStore = globalStore !== undefined && globalStore !== null
            ? globalStore
            : GlobalStore.Get();
        this._fxpRouterService = fxpRouterService !== undefined && fxpRouterService !== null
            ? fxpRouterService
            : this.CreateFxpRouterService();
        this._reducerFactory = reducerFactory !== undefined && reducerFactory !== null
            ? reducerFactory
            : this.CreateReducerFactory(this._fxpRouterService);
        this._store = null;
    }
    PlatformStateRouter.Get = function () {
        var globalPlatformStateRouteInstance = window["globalPlatformStateRouteInstance"] || null;
        if (globalPlatformStateRouteInstance === null) {
            globalPlatformStateRouteInstance = new PlatformStateRouter();
            window["globalPlatformStateRouteInstance"] = globalPlatformStateRouteInstance;
        }
        return globalPlatformStateRouteInstance;
    };
    PlatformStateRouter.prototype.Init = function () {
        if (this._store === null) {
            this._store = this.BuildRouterStore();
        }
        else {
            console.warn("WARNING: Router store cannot be initialized multiple times.");
        }
    };
    PlatformStateRouter.prototype.SubscribeToRouteChange = function (source, callback) {
        return this._globalStore.SubscribeToPartnerState(source, PLATFORM_ROUTER_STORE_NAME, callback);
    };
    PlatformStateRouter.prototype.GetCurrentRoute = function () {
        var routeState = this._globalStore.GetPartnerState(PLATFORM_ROUTER_STORE_NAME);
        if (routeState !== undefined && routeState !== null) {
            return routeState.CurrentRoute;
        }
        else {
            return null;
        }
    };
    PlatformStateRouter.prototype.GetHistory = function () {
        var routeState = this._globalStore.GetPartnerState(PLATFORM_ROUTER_STORE_NAME);
        if (routeState !== undefined && routeState !== null) {
            return routeState.History;
        }
        else {
            return null;
        }
    };
    PlatformStateRouter.prototype.BuildRouterStore = function () {
        var reducer = this.BuildReducer();
        var store = this._globalStore.CreateStore(PLATFORM_ROUTER_STORE_NAME, reducer, []);
        this._globalStore.RegisterGlobalActions(PLATFORM_ROUTER_STORE_NAME, ["*"]);
        return store;
    };
    PlatformStateRouter.prototype.BuildReducer = function () {
        var routeConfigurationReducer = this._reducerFactory.GetConfigurationReducer();
        var updateRouteConfigurationReducer = this._reducerFactory.UpdateRouteConfigurationReducer();
        var currentRouteReducer = this._reducerFactory.GetCurrentRouteReducer();
        var historyReducer = this._reducerFactory.GetHistoryReducer();
        var naviagatiionReducer = this._reducerFactory.GetNavigationReducer();
        var reducer = function (state, action) {
            if (state === void 0) { state = DefaultRouteState; }
            return {
                RouteConfiguration: routeConfigurationReducer(state.RouteConfiguration, action),
                UpdateRouteConfigurationReducer: updateRouteConfigurationReducer(state.RouteConfiguration, action),
                CurrentRoute: currentRouteReducer(state, action),
                History: historyReducer(state.History, action),
                Transition: naviagatiionReducer(state.Transition, action)
            };
        };
        return reducer;
    };
    PlatformStateRouter.prototype.CreateFxpRouterService = function () {
        try {
            return FxpServiceFactory.getServiceInstance(FXPServiceCatalog.FxpRouteService);
        }
        catch (error) {
            console.error("There was an error while getting the route service");
            console.error(error);
            return null;
        }
    };
    PlatformStateRouter.prototype.CreateReducerFactory = function (fxpRouteService) {
        return new ReducerFactory(fxpRouteService);
    };
    return PlatformStateRouter;
}());
export { PlatformStateRouter };
//# sourceMappingURL=platform.state.router.js.map